import { Typography } from "@mui/material";

import Colors from "../../../../../../styles/Colors";
import Svg from "../../../../../ui library/components/svgs/standard/svg";

export default function DashboardCard({ title, icon, children, gridColumns = 1, span = 1 }) {
  const columns = "grid-cols-" + gridColumns;
  const colspan = "col-span-" + span;

  return (
    <div className={`border-box flex h-60 min-w-[245px] flex-col ${colspan}`} style={{ flex: "1" }}>
      <div
        className="flex items-center w-full gap-2 p-2 py-2 text-center text-black bg-white text-md border-slate-200"
        style={{
          borderBottom: "3px solid #cdd4de",
          marginBottom: "1.1rem",
        }}
      >
        {icon && <Svg name={icon} color={Colors.blue[500]} sx={{ width: "29px" }} />}
        <Typography className="text-2xl">{title}</Typography>
      </div>
      <div className={`grid h-[64%] ${columns}`}>{children}</div>
    </div>
  );
}
